import { render, staticRenderFns } from "./scratchpad.vue?vue&type=template&id=9f96b6f6&scoped=true&"
import script from "./scratchpad.vue?vue&type=script&lang=js&"
export * from "./scratchpad.vue?vue&type=script&lang=js&"
import style0 from "./scratchpad.vue?vue&type=style&index=0&id=9f96b6f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f96b6f6",
  null
  
)

export default component.exports